import { IRELAND } from '@nxsys/store/constants/keys';

// NX-6147: UK Home Office entries that do not apply to an Ireland employer.
export const UK_ONLY_RIGHT_TO_WORK_STATUSES = [
  'TIER_1_VISA',
  'TIER_2_WORK_PERMIT',
  'TIER_4_STUDENT_VISA',
  'TIER_5_TEMP_WORKERS/YOUTH_MOBILITY',
];
export const UK_ONLY_DOCUMENT_TYPES = ['BIOMETRIC_RESIDENCE_PERMIT'];

type SelectOption = { value?: string; options?: SelectOption[] };

const withoutUkOnly = <T extends SelectOption>(
  options: T[],
  ukOnly: string[],
  keepValue?: string,
): T[] =>
  options
    .filter(
      (option) =>
        !option.value ||
        !ukOnly.includes(option.value) ||
        option.value === keepValue,
    )
    .map((option) =>
      option.options
        ? {
            ...option,
            options: withoutUkOnly(option.options, ukOnly, keepValue),
          }
        : option,
    );

// Dropdown options for an employer's country. `keepValue` is the value the
// record already holds: it stays selectable so an older Ireland record still
// shows its label instead of the raw code.
export const getRightToWorkStatusOptions = <T extends SelectOption>(
  options: T[],
  payrollCountry?: string,
  keepValue?: string,
): T[] =>
  payrollCountry === IRELAND
    ? withoutUkOnly(options, UK_ONLY_RIGHT_TO_WORK_STATUSES, keepValue)
    : options;

export const getDocumentTypeOptions = <T extends SelectOption>(
  options: T[],
  payrollCountry?: string,
  keepValue?: string,
): T[] =>
  payrollCountry === IRELAND
    ? withoutUkOnly(options, UK_ONLY_DOCUMENT_TYPES, keepValue)
    : options;
